import { DateTime } from "luxon";
import Image from "next/image";
import { GalleryChild } from "../types/GalleryChild";

const EventGalleryChildItem = (galleryChild: GalleryChild) => {
  const happeningAt = DateTime.fromISO(galleryChild.happening_at);

  return (
    <article className="container px-5 pt-10">
      
      <h4 className="mb-5 text-xl text-black/80">
        {`${happeningAt.monthShort} ${happeningAt.year}`}
      </h4>

      <div 
        className="prose lg:prose-lg max-w-full prose-headings:text-gray1 text-gray1" 
        dangerouslySetInnerHTML={{ __html: galleryChild.description }}
      ></div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 my-14 gallery">
        {galleryChild.photos.map((photo) => (
          <a key={photo.id} href={photo.url} rel="noreferrer" target="_blank">
            <div className="shadow-lg rounded-lg h-32 md:h-56 w-full overflow-hidden relative">
              <Image src={photo.url} layout="fill" objectFit="cover" alt={photo.file_name} />
            </div>
          </a>
        ))}
      </div>
    </article>
  );
};

export default EventGalleryChildItem;
